<app-multi-select-dropdown
    [context]="context"
    [dropdownLabel]="ruleLabel"
    [options]="rules$ | async"
    [isMultiSelect]="isMultiSelect"
    (submitDropdownMultiSelect)="submitDropdownMultiSelect($event)"
    (submitDropdownSingleSelect)="submitDropdownSingleSelect($event)"
>
</app-multi-select-dropdown>
